import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const CompleteValidation = lazy(() => import('../../container/facilitator/validation/CompleteValidations'));
const PendingValidations = lazy(() => import('../../container/facilitator/validation/PendingValidations'));
const BorrowerValidations = lazy(() => import('../../container/facilitator/validation/BorrowerValidations'));
const InvestorValidations = lazy(() => import('../../container/facilitator/validation/InvestorValidations'));
const ProjectValidations = lazy(() => import('../../container/facilitator/validation/ProjectValidations'));
const InvestmentValidations = lazy(() => import('../../container/facilitator/validation/InvestmentValidations'));
const ValidationDetails = lazy(() => import('../../container/facilitator/validation/ValidationDetails'));
function PagesRoute() {
  return (
    <Routes>
      <Route path="borrower/:borrowerId" element={<BorrowerValidations />} />
      <Route path="investor/:investorId" element={<InvestorValidations />} />
      <Route path="project/:projectId" element={<ProjectValidations />} />
      <Route path="investment/:investmentId" element={<InvestmentValidations />} />
      <Route path=":validationId" element={<ValidationDetails />} />
      <Route path="pending" element={<PendingValidations />} />
      <Route path="completed" element={<CompleteValidation />} />
    </Routes>
  );
}

export default PagesRoute;
